export { default } from "./Svg";
export { default as LegacySvg } from "./LegacySvg";
export type { SvgProps } from "./Svg";
export type { LegacySvgProps } from "./LegacySvg";
